export enum ErrorType {
  ERROR_404 = "ERROR_404",
  ERROR_403 = "ERROR_403",
  ERROR_500 = "ERROR_500",
  ERROR_RENDERING = "ERROR_RENDERING",
  ERROR_USER_DISABLED = "ERROR_USER_DISABLED",
  LOGGED_OUT = "LOGGED_OUT",
  ADMIN_DETECTOR_LIST_BLOCKED = "ADMIN_DETECTOR_LIST_BLOCKED",
  ADMIN_GLOBAL_REVIEW_BLOCKED = "ADMIN_GLOBAL_REVIEW_BLOCKED",
}

/** Either navigates to `link`, or stays on the current URL and merges `addSearchParams` into its query string. */
export type Redirect =
  | {
      title: string;
      link: string;
    }
  | {
      title: string;
      addSearchParams: Record<string, string>;
    };

export type ErrorData = {
  title: string;
  subtitle: string;
  description: string;
  redirect?: Redirect;
};
